<template>
    <div class="dashboard-grid" :style="gridStyle">
      <slot></slot>
    </div>
  </template>
  
  <script>
  export default {
    name: "SGPGridComponent",
    props: {
      columns: {
        type: Number,
        default: 8, // Padrao 8 caso nao informado
      },
    },
    computed: {
      gridStyle() {
        return {
          gridTemplateColumns: `repeat(${this.columns}, 1fr)`,
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .dashboard-grid {
    display: grid;
    gap: 18px;
  }
  </style>
  